import { render, staticRenderFns } from "./SmsDetailInfo.vue?vue&type=template&id=476d33ba&"
import script from "./SmsDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./SmsDetailInfo.vue?vue&type=script&lang=ts&"
import style0 from "./SmsDetailInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports